import script from "./StudioComboSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudioComboSelect.vue?vue&type=script&setup=true&lang=ts"

import "./StudioComboSelect.vue?vue&type=style&index=0&id=27cf4f98&lang=scss"

const __exports__ = script;

export default __exports__